import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-lg border border-border p-4 md:p-5 hover:shadow-md transition-shadow duration-200"
        >
          <div className="flex items-center gap-3 mb-2">
            <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center ${stat?.bgColor}`}>
              <Icon name={stat?.icon} size={20} className={stat?.iconColor} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs md:text-sm text-muted-foreground mb-0.5">
                {stat?.label}
              </p>
              <p className="text-xl md:text-2xl font-semibold text-foreground">
                {stat?.value}
              </p>
            </div>
          </div>
          {stat?.trend && (
            <div className="flex items-center gap-1 text-xs text-success">
              <Icon name="TrendingUp" size={12} />
              <span>{stat?.trend}</span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;